import {useCallback, useEffect, useState} from 'react'

const STORAGE_KEY = 'view_note_ids_gallery'
const VIEW_CAP = 2

function readViewedIds(): string[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : []
  } catch {
    return []
  }
}

function writeViewedIds(ids: string[]): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids))
  } catch {
    // storage disabled / quota exceeded — fail open
  }
}

export function useLocalNoteViewCount() {
  const [viewedCount, setViewedCount] = useState(0)

  useEffect(() => {
    setViewedCount(readViewedIds().length)
  }, [])

  const recordView = useCallback((noteId: string) => {
    const current = readViewedIds()
    if (current.length >= VIEW_CAP || current.includes(noteId)) {
      setViewedCount(current.length)
      return
    }
    const next = [...current, noteId]
    writeViewedIds(next)
    setViewedCount(next.length)
  }, [])

  const isAtCap = viewedCount >= VIEW_CAP

  return {viewedCount, recordView, isAtCap}
}
